
import { computed, defineComponent, onMounted, ref, watch } from 'vue';
import { DassIcon } from 'ds-ui';

export default defineComponent({
  props: {
    filterTag: {
      type: Array,
      default: () => [],
    },

    visibility: {
      type: Boolean,
      default: false,
    },

    hasModification: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DassIcon,
  },
  setup(props, { emit }) {
    const refModal = ref();
    const visibilityRef = computed(() => props.visibility);

    const closeModal = () => {
      refModal.value.style.display = 'none';
      emit('update:visibility', false);
      emit('close-modal');
    };

    onMounted(() => {
      window.onclick = function (event) {
        if (event.target == refModal.value) {
          refModal.value.style.display = 'none';
          emit('update:visibility', false);
          emit('close-modal');
        }
      };
    });

    watch(visibilityRef, (newValue) => {
      newValue === true
        ? (refModal.value.style.display = 'block')
        : (refModal.value.style.display = 'none');
    });

    const cancel = () => {
      closeModal();
      // emit('cancel');
    };
    return { refModal, closeModal, emit, cancel };
  },
});
